module.exports = __webpack_public_path__ + "img/Erftverband_logo.e1a27263.png";